module.exports = __webpack_public_path__ + "assets/img/avatar-10.1bd27b28.jpg";